import React, { Component } from 'react';
import * as VK from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';

export default class LoaderSpinner extends Component {

    render() {
        return (
            <VK.Div style={{ marginBottom: 12 }}>
                <VK.Spinner className="spinner" />
            </VK.Div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/components/LoaderSpinner.js